import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import request from '@/utils/request';
export function getInfo(token) {
  return request({
    url: '/vue-admin-template/user/info',
    method: 'get',
    params: {
      token: token
    }
  });
}
export function logout() {
  return request({
    url: '/orders/login/logout',
    method: 'post'
  });
}
export function login(data) {
  return request({
    url: 'https://package-advtest.youlianfuwu.com/v1/auto-login/index',
    method: 'post',
    data: data
  });
}
export function getAbility(params) {
  return request({
    url: '/package/default/permissions',
    method: 'get',
    params: params
  });
}
// 获取销售人员列表
export function getSellUsers(params) {
  return request({
    url: 'package/package-programme/user-ids',
    method: 'get',
    params: params
  });
}
// 获取公司名称
export function getCompanyInfo() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/package/customer/data',
    method: 'get',
    params: _objectSpread({
      is_delete: '0'
    }, params),
    timeout: 3 * 60 * 1000
  });
}
/**
 * 修改密码
 * @param {*} params
 * @returns
 */
export function changePassword(params) {
  return request({
    url: '/orders/login/changepw',
    method: 'get',
    params: params
  });
}
// 获取菜单权限
export function getMenus(data) {
  return request({
    url: '/orders/menu/menus',
    method: 'post',
    data: data
  });
}
// 更换系统模式
export function changeSystem(data) {
  return request({
    url: '/orders/user/set-work-mode',
    method: 'post',
    data: data
  });
}
// 获取模式
export function getSystemMode(params) {
  return request({
    url: '/orders/user/get-work-mode',
    method: 'get',
    params: params
  });
}
// 用户头像
export function getMyAvatar(params) {
  return request({
    url: '/user/user/get-my',
    method: 'get',
    params: params
  });
}
// 修改头像
export function changeAvatar(data) {
  return request({
    url: '/user/user/bind-avatar',
    method: 'post',
    data: data
  });
}
// 获取当班客服 as_array=1 接口返回数组
export function getServiceName(params) {
  return request({
    url: '/kefuapi/clock-record/sign-in-persons',
    method: 'get',
    params: _objectSpread({
      as_array: 1
    }, params)
  });
}
// 记录日志
export function getUserAddLog(data) {
  return request({
    url: '/user/access-log/add-log',
    method: 'post',
    data: data
  });
}
// 是否展示绑定企业微信入口，接口返回 true 展示、false 不展示
export function getEnterpriseWechatAuth(params) {
  return request({
    url: '/user/wechat-login/get-enterprise-wechat-auth',
    method: 'get',
    params: params
  });
}
// 绑定企业微信，code 为企业微信登录组件回调的授权码
export function bindEnterpriseWechat(params) {
  return request({
    url: '/user/wechat-login/enterprise-wechat-auth',
    method: 'get',
    params: params
  });
}